import { Table } from 'antd';
import { useNavigate } from 'react-router-dom';

import { PREFIX, SENDOUTS_TABLE_HEADER, U_KEY } from '@app/constants';
import { useRightsToSendouts, useWindowSize } from '@app/hooks';
import { usePagination } from '@app/pages/Sendouts/hooks/usePagination';

import { useSendoutsEffects } from '@pages/Sendouts/SendoutsList/hooks/useSendoutsEffects';

import { SendoutsFilterForm } from '@pages/Sendouts/SendoutsList/components/SendoutsFilterForm';

import { adaptDataToTable } from '@pages/Sendouts/SendoutsList/utils/adaptDataToTable';

import '@app/pages/Sendouts/SendoutsList/styles/Sendouts.desktop.scss';

export const Sendouts = () => {
  const { pageNumber, rowsPerPage, totalRowsCount, setTotal, change } =
    usePagination();

  const navigate = useNavigate();

  const { isMobile } = useWindowSize();

  const { data, isLoading, startSendout, stopSendout, setParams } =
    useSendoutsEffects(pageNumber, rowsPerPage, setTotal);

  const { isAccessToManageSendoutInSendouts } = useRightsToSendouts();

  return (
    <div className={`${PREFIX}sendouts`}>
      <SendoutsFilterForm onChange={setParams} />
      <div>
        <Table
          className="table"
          loading={isLoading}
          rowKey={(record) => String(record[U_KEY])}
          rowClassName={'sendout-item'}
          columns={SENDOUTS_TABLE_HEADER}
          dataSource={adaptDataToTable(
            data?.Data || [],
            isAccessToManageSendoutInSendouts,
            startSendout,
            stopSendout,
            navigate
          )}
          pagination={{
            size: isMobile ? 'small' : 'default',
            showSizeChanger: true,
            total: totalRowsCount,
            pageSize: rowsPerPage,
            position: ['bottomLeft'],
            current: pageNumber,
            onChange: change,
            showTotal: (total, range) =>
              `Показаны ${range[0]}-${range[1]} из ${total}`,
          }}
        />
      </div>
    </div>
  );
};
